module.exports = __webpack_public_path__ + "static/upraisal-technology2-94d47bc8582e27eb9583f37078b533b6.png";